import React, { useState, useEffect } from "react";

import axios from "axios";
import TldrTitleRow from "../_components/styled/home/TldrTitleRow";
import { ShowCenterSpinner } from "../_components/common/statelessView";
import AiLastRuns from "./AiLastRuns";
import { connect } from "react-redux";
import { getDocuments, resetDocument } from "../_actions/aiDocumentActions";
import { handleHTTPError } from "../_actions/errorHandlerActions";
import { resetCardsSelection } from "../_actions/folderActions";
import { moveToFolder } from "../_actions/folderActions";
import { ShowNoContent } from "../_components/common/statelessView";
import { EmptyStateScreen } from "../_components/styled/home/statelessView";
import {
  DOCUMENTS,
  MY_DOCUMENTS,
  SHARED_WITH_ME_DOCUMENTS,
} from "../_utils/routes";
import TLDRTitleSearch from "../_components/common/TLDRTitleSearch";
import TldrSearch from "../_components/common/TldrSearch";
import PageTitleDD from "../_components/common/PageTitleDD";
import { ContentTypes, DOCUMENTS_KEY } from "../_utils/constants";
import { deleteItemsInBulk, resetPage } from "../_actions/sidebarSliderActions";
import RecentFoldersRow from "../_components/home/RecentFoldersRow";
import { StyledMarketPlaceGallery } from "../_components/styled/home/stylesHome";
import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import TldrTitleSearchRow from "../_components/styled/home/TldrTitleSearchRow";
import TldrSelectedCardsRow from "../_components/styled/home/TldrSelectedCardRow";
import TldrMobileSearchSuggestion from "../_components/common/TldrMobileSearchSuggestion";

const documentDDItems = [
  {
    id: "documents",
    label: "All documents",
    path: DOCUMENTS,
  },
  {
    id: "my-documents",
    label: "My documents",
    path: MY_DOCUMENTS,
  },
  {
    id: "shared-with-me",
    label: "Shared with me",
    path: SHARED_WITH_ME_DOCUMENTS,
  },
];

function TldrSavedCopies(props) {
  const { t } = useTranslation(["ai", "common"]);
  let _isMounted = true;
  const signal = axios.CancelToken.source();

  const [loaded, setLoaded] = useState(false);
  const [search, setSearchTerm] = useState("");
  const { payload } = props.documents;
  const [showMobileSuggestions, setShowMobileSuggestions] = useState(false);

  function fetchSavedCopies(searchTerm) {
    setLoaded(false);
    const { selectedPage, auth } = props;
    let creatorId,
      excludeCreatorId = null;
    switch (selectedPage) {
      case MY_DOCUMENTS:
        creatorId = auth?.payload?.user?.pk;
        break;
      case SHARED_WITH_ME_DOCUMENTS:
        excludeCreatorId = auth?.payload?.user?.pk;
        break;
      default:
    }

    props
      .getDocuments(
        { ...props, creatorId: creatorId, excludeCreatorId: excludeCreatorId },
        searchTerm,
        signal
      )
      .then(() => {
        setLoaded(true);
      });
  }

  function handleSearch(searchTerm) {
    if (_isMounted) {
      setSearchTerm(searchTerm);
    }
  }

  function handleClearSearch() {
    setSearchTerm("");
    props.resetDocument();
    fetchSavedCopies("");
  }

  useEffect(() => {
    props.resetDocument();
    fetchSavedCopies("");
    return () => {
      signal.cancel("The user aborted a request.");
      _isMounted = false;
    };
  }, []);

  function handleSearchAiDocuments() {
    setShowMobileSuggestions(false);
    props.resetDocument();
    fetchSavedCopies(search);
  };

  function moveToFolder(folderId, folderName) {
    const { selectedCards } = props;
    let documentIds = [];

    selectedCards.forEach((item) => {
      documentIds.push(item.content_id);
    });
    const payload = {
      content_ids: documentIds,
    };
    props.resetPage("");

    return new Promise((resolve, reject) => {
      props
        .moveToFolder(payload, folderId, folderName, signal.token)
        .then((res) => {
          fetchSavedCopies("");
          props.resetCardsSelection();
          resolve();
        });
    });
  }

  function deleteSelected() {
    const { selectedCards } = props;
    let aiDocumentIds = [];

    selectedCards.forEach((item) => {
      aiDocumentIds.push(item.content_id);
    });

    if (aiDocumentIds.length > 0) {
      return new Promise((resolve, reject) => {
        props
          .deleteItemsInBulk(
            {
              ...props,
              type: ContentTypes.AI_DOCUMENT,
              ids: aiDocumentIds,
            },
            signal.token
          )
          .then(() => {
            resolve();
          });
      });
    }
  }

  function handleSearchFocusOnMobile() {
    setShowMobileSuggestions(true);
  };

  function handleSearchBlurOnMobile() {
    setShowMobileSuggestions(false);
  };

  return (
    <>
      {!props.renderlocation ? (
        <>
          {props.selectedCards.length > 0 && !props.isMobileView ? (
            <TldrSelectedCardsRow
              type="story"
              displayType="item"
              displayNamePluralForm="stories"
              marginTop="-1.95rem"
              marginBottom="-0.15rem"
              onMoveToFolder={moveToFolder}
              onDeleteSelected={() => deleteSelected()}
            />
          ) : !props.isMobileView ? (
            <Flex
              direction="row"
              align="center"
              justify="space-between"
              py="0"
              px="2.5rem"
              minH="36px"
              mb="0"
            >
              <TldrTitleRow
                titleComponent={<PageTitleDD ddItems={documentDDItems} />}
                title={t("ai.documents")}
                subTitle={t("tldrSubtitle")}
                classes="saved-copies-title-row"
              />

              <TldrTitleSearchRow
                handleSearch={handleSearch}
                  onClear={handleClearSearch}
                searchPlaceholder={t("search_docs")}
                showNewFolderButton
                  handleEnterKeyEvent={handleSearchAiDocuments}
              />
            </Flex>
          ) : null}

          {/* for mobile view */}
          {props.isMobileView ? (
            <>
              <TLDRTitleSearch
                searchConfig={{
                  onClear: handleClearSearch,
                  onFocus: handleSearchFocusOnMobile,
                }}
                searchText={search}
                placeholder={t("search_docs")}
              />

              {showMobileSuggestions ? (
                <TldrMobileSearchSuggestion
                  searchTerm={search}
                  searchInFormats={false}
                  isOpen={showMobileSuggestions}
                  searchConfig={{
                    handleSearch: handleSearch,
                    onBlur: handleSearchBlurOnMobile,
                    onClear: handleClearSearch,
                    handleEnterKeyEvent: handleSearchAiDocuments
                  }}
                  placeholder={t("search_docs")}
                />
              ) : null}
            </>
          ) : null}
        </>
      ) : (
        <>
          <TldrSearch
            placeholder={t("search_docs")}
            width="100%"
            searchLocation="studio"
            onSearch={handleSearch}
          />

          {props.renderlocation === "calendar" ||
              props.renderlocation === "editor" ? (
            <Box mb="3" />
          ) : null}
        </>
      )}

      <StyledMarketPlaceGallery renderlocation={props.renderlocation}>
        {props.showRecentFolders ? (
          <RecentFoldersRow parentLocation={DOCUMENTS} />
        ) : null}

        {payload?.length > 0 ? (
          <AiLastRuns
            results={payload}
            renderlocation={props.renderlocation}
            onCreateNewDocument={props.onCreateNewDocument}
            showExtraOptions={props.showExtraOptions}
          />
        ) : loaded && search === "" ? (
          <ShowCenterSpinner loaded={loaded} />
        ) : loaded && search !== "" ? (
          <ShowNoContent text="No results found." />
        ) : (
          <ShowCenterSpinner loaded={loaded} />
        )}

        {payload?.length === 0 && search === "" && loaded ? (
          <EmptyStateScreen
            title={t("no_docs")}
            description={t("create_docs")}
            actionButtonOnClick={props.onCreateNewDocument}
            actionButtonPlaceholder={t("go_to_playground")}
          />
        ) : null}
      </StyledMarketPlaceGallery>
    </>
  );
}

TldrSavedCopies.propTypes = {};

TldrSavedCopies.defaultProps = {
  showExtraOptions: false,
};

const mapStateToProps = (state) => {
  return {
    documents: state.document,
    folders: state.folders.folders,
    selectedCards: state.folders.selectedCards,
    auth: state.auth,
    workspacePermissionChecks: state.permissions.workspacePermissionChecks,
    isMobileView: state.app.isMobileView,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleHTTPError: (error, props) => dispatch(handleHTTPError(error, props)),
    getDocuments: (props, search, signal) =>
      dispatch(getDocuments(props, search, signal)),
    resetCardsSelection: () => dispatch(resetCardsSelection()),
    moveToFolder: (payload, folderId, folderName, token) =>
      dispatch(moveToFolder(payload, folderId, folderName, token)),
    resetDocument: () => dispatch(resetDocument()),
    deleteItemsInBulk: (props, token) =>
      dispatch(deleteItemsInBulk(props, token)),
    resetPage: (payload) => dispatch(resetPage(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TldrSavedCopies);
